export default "__VITE_ASSET__CaQ0NKlj__"